/* eslint-disable */

import request from '@/utils/request'

export function getListRoomPropertyApi(query) {
  return request({
    url: '/config-service/v1/hotel/room_property',
    method: 'get',
    params: query
  })
}
export function getAllRoomPropertyApi() {
  return request({
    url: '/config-service/v1/hotel/room_property/all',
    method: 'get'
  })
}

export function addRoomPropertyApi(query) {
  return request({
    url: '/config-service/v1/hotel/room_property',
    method: 'post',
    data: query
  })
}

export function updateRoomPropertyApi(query) {
  return request({
    url: '/config-service/v1/hotel/room_property',
    method: 'put',
    data: query
  })
}
export function deleteRoomPropertyApi(query) {
  return request({
    url: '/config-service/v1/hotel/room_property',
    method: 'delete',
    data: query
  })
}
